import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { WelcomeModal } from './WelcomeModal.tsx';
import { DeviceFrame } from './DeviceFrame.tsx';
import waveImg from '@/assets/wave.png';
import { TTGlowingLogo } from './Icons.tsx';
// import { Button } from '@ethsign/ui';
// import okxIcon from '@/mod-airdrop/assets/okx.png';
import { GradientButton } from '@/components/GradientButton.tsx';

export function TonWrapper({ children }: { children: React.ReactNode }) {
  const [tonConnectUI] = useTonConnectUI();
  // const navigate = useNavigate();

  // const handleConnectWallet = async (walletName: string) => {
  //   await tonConnectUI.openSingleWalletModal(walletName);
  // };
  const wallet = useTonWallet();

  // useEffect(() => {
  //   if (!isTelegramApp()) return;
  //   const BackButton = WebApp.BackButton;

  //   BackButton.show();
  //   BackButton.onClick(() => {
  //     navigate('/airdrop');
  //   });
  // }, []);

  return (
    <DeviceFrame>
      {wallet ? (
        <>
          {children}
          <WelcomeModal flag={'ton'} />
        </>
      ) : (
        <div className={'py-10 absolute bottom-0 w-full rounded-t-[16px] bg-card'}>
          <div
            className={'py-10 px-10 text-center relative'}
            style={{
              background: `url(${waveImg}) center center no-repeat`
            }}
          >
            <div className={'flex justify-center'}>
              <TTGlowingLogo />
            </div>
            <h1 className={'mt-5 text-[25px] font-bold'}>Claim Airdrop Tokens</h1>
            <div className="text-secondary-foreground text-center text-xs font-medium">
              Your tokens are awaiting. Ready to claim?
            </div>
            <GradientButton
              className={'w-full mt-6'}
              size={'lg'}
              onClick={() => {
                tonConnectUI.modal.open();
              }}
            >
              Connect Wallet
            </GradientButton>
            {/*<Button*/}
            {/*  variant={'outline'}*/}
            {/*  className={'w-full mt-6 border-primary-foreground text-primary-foreground gap-2'}*/}
            {/*  onClick={() => {*/}
            {/*    handleConnectWallet('okxTonWallet');*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <img src={okxIcon} className={'w-9 h-auto'} alt="" />*/}
            {/*  OKX Wallet*/}
            {/*  {GlobalConfig.OkxGasRefund && (*/}
            {/*    <div*/}
            {/*      className={'text-xs text-base bg-[#BBFF34] rounded-[50px] px-2 py-1'}*/}
            {/*      style={{*/}
            {/*        boxShadow: '0px 0.583px 1.165px 0px rgba(16, 24, 40, 0.05)'*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      🔥0 Gas Fee*/}
            {/*    </div>*/}
            {/*  )}*/}
            {/*</Button>*/}
          </div>
          <WelcomeModal flag={'ton'} />
        </div>
      )}
    </DeviceFrame>
  );
}
